import { styled, Typography } from "@mui/material";
import { useTheme } from "@mui/system";
import TotalPriceIcon from "assets/icons/TotalPriceIcon";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import TableSelectInvoice from "components/Input/TableSelectInvoice";
import { PriceComponent } from "components/Shared/Dashboard/styled";
import { ExportContainer, Item } from "components/Table/ExportBotton";
import { indexData } from "forms";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";
import { formatPrice } from "helpers/dataFormat";
import useDateState from "helpers/useDateState";
import { useSelector } from "react-redux";
import { StyledListItemIcon, StyledListItemText } from "./components";
import { getQueryParam } from "helpers/queryParam";
import { store } from "store/store";
import axios from '../../axios/axios'
import { DateToString } from "./DateFilter";
import fileDownload from "js-file-download";
import { errorDispatcher } from "helpers";
import { appSetLoading } from "store/actions/appAction";

const MainContainer = styled("div")(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  margin: "20px 0px",
  display: "flex",
  flexDirection: "column",
}));
const LowerSectionContainer = styled("div")(({ theme }) => ({
  backgroundColor: "white",
  display: "flex",
  flexWrap: "wrap",
  gap: "24px",
  padding: "10px",
  borderRadius: theme.shape.borderRadius,
  justifyContent: "space-between",
}));
const UpperSection = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: 20,
  alignItems: "center",
  width: "100%",
  marginBottom: "10px",
}));

const PriceItemContainer = styled("div")(({ theme }) => ({
  width: "200px",
  display: "flex",
  justifyContent: "space-between",
}));
const PriceItemLeft = styled("div")(({ theme }) => ({
  width: "150px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
}));

const PriceItem = ({ title, price }: { title: string; price: number }) => {
  const theme = useTheme();

  return (
    <PriceItemContainer>
      <TotalPriceIcon />
      <PriceItemLeft>
        <Typography variant="body2" color={theme.palette.disabled.main}>
          {title}
        </Typography>
        <PriceComponent price={formatPrice(price)} />
      </PriceItemLeft>
    </PriceItemContainer>
  );
};

const InvoiceUpperComponent = ({
  isSell,
  refetch,
  type,
}: {
  isSell?: boolean;
  refetch: (args: any) => void;
  type?: string;
}) => {
  const tabs = indexData(type);

  const { setDates, toDate, fromDate } = useDateState(tabs && tabs[0]);
  const reportReducer = useSelector((state: any) => state).reportReducer;
  const { getState, dispatch } = store
  const Token = getState().businessReducer.business?.token;


  const totalList = isSell ? reportReducer?.salesByFactor?.totalList : reportReducer?.buysByFactor?.totalList;
  const downloadExcel = () => {
    const data = {
      excel: true,
      "subColumn": "date",
      "searchText": fromDate,
      "searchTextAlt": toDate,

    };
    const productId = getQueryParam("productId");

    let url = `/reports/${isSell ? "salesByFactor" : 'buysByFactor'}?productId=${productId}`;

    const tokenHeader = { Authorization: `Bearer ${Token}` };
    axios
      .post(url, data, {
        headers: { ...tokenHeader },
        responseType: "blob",
      })
      .then((response) => {
        const now = DateToString(Date.now()).replace("/", "_");
        fileDownload(response.data, `buysByFactor${now}.xlsx`);
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      }).finally(() => dispatch(appSetLoading(false)))
  }
  return (
    <MainContainer>
      <UpperSection>
        <div style={{ width: 245 }}>
          <BasicDateInput
            range
            placeholder="کل سال مالی"
            onChange={(x) => setDates(x)}
            defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
          />
        </div>
        <TableSelectInvoice refetch={refetch} />
        <ExportContainer>
          <Item disableRipple onClick={downloadExcel}>
            <StyledListItemIcon>
              <SnippetFolderIcon color="success" />
            </StyledListItemIcon>
            <StyledListItemText sx={{ minWidth: '5rem' }}> دانلود اکسل </StyledListItemText>
          </Item>
        </ExportContainer>
      </UpperSection>
      <LowerSectionContainer>
        <PriceItem title="مبلغ" price={totalList?.totalInitialPrice} />
        <PriceItem title="تخفیف" price={totalList?.totalDiscount} />
        <PriceItem title="مالیات" price={totalList?.totalTax} />
        <PriceItem title="مبلغ کل" price={totalList?.totalFinalPrice} />
      </LowerSectionContainer>
    </MainContainer>
  );
};

export default InvoiceUpperComponent;
